export const OPT_IN_KEYWORDS = ['start', 'unstop', 'optin'];
export const OPT_OUT_KEYWORDS = ['end', 'quit', 'stop', 'stopall', 'unsubscribe'];
export const HELP_KEYWORDS = ['help', 'info'];
export const ADD_KEYWORDS = ['add', 'pickup'];

export * from './blocks-words';
export * from './score-words';
export * from './numeric-forbidden-word-type-to-string';
